module.exports = __webpack_public_path__ + "static/media/change_seat.3ab1d28e.png";